import {addLazyScroll} from 'app/components/tabNavigation/utils/addLazyScroll';
import {getTemplates} from 'app/components/tabNavigation/utils/getTemplates';
import {ShouldSkipLazyLoadFn, ShouldSkipLazyLoadType} from 'app/interface';
import {addScrollDeeplinkItemAction} from 'app/modules/scrollDeeplink/actions';
import {getLoadingType} from 'app/utils/initialize/getLoadingType';
import {shouldSkipLazyLoadNested} from 'app/utils/initialize/shouldSkipLazyLoadNested';
import {TabNavigationConfig} from 'interfaces/common/components/general/tab/tabNavigationConfig';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn<TabNavigationConfig> = ({element, config}) => {
    const cId = config?.cId;
    if (!cId || !config.tabItems) {
        return 'LOAD_LAZY';
    }

    const results = new Set<ShouldSkipLazyLoadType>();
    if (addLazyScroll(cId, config.tabItems)) {
        results.add('LOAD_EAGER_WITH_SCROLL_TO');
    }

    getTemplates(element).forEach((item, index) => {
        addScrollDeeplinkItemAction({type: 'DEEPLINK', cId: item.cId, list: [item.cId]});

        const skipLazyLoad = shouldSkipLazyLoadNested(item.templateElement.content);
        if (skipLazyLoad === 'LOAD_EAGER_WITH_SCROLL_TO') {
            addScrollDeeplinkItemAction({cId, type: 'LAZY_SCROLL', component: 'TAB_NAVIGATION', tabIndex: index});
        }

        results.add(skipLazyLoad);
    });

    return getLoadingType(results);
};
